import { render, staticRenderFns } from "./OperationsCopyButton.vue?vue&type=template&id=7f0652d0&scoped=true&"
import script from "./OperationsCopyButton.vue?vue&type=script&lang=js&"
export * from "./OperationsCopyButton.vue?vue&type=script&lang=js&"
import style0 from "./OperationsCopyButton.vue?vue&type=style&index=0&id=7f0652d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0652d0",
  null
  
)

export default component.exports